<template>
	<ViewWrapper :carregando="loading" :permissao="PERMISSOES_FGTAS.ACESSO_TOTAL">
		<template #titulo>
			<span v-if="isCadastroOuEditar">{{ dadosAgencia.id ? "Editar" : "Cadastrar" }} Agência</span>
			<span v-else>Gerenciar Agências</span>
		</template>
		<template #botaoHeader>
			<v-row v-if="!isCadastroOuEditar" justify="center">
				<v-col cols="12" class="align-content-center">
					<v-btn
						block
						color="primary"
						text="NOVA AGÊNCIA"
						@click="isCadastroOuEditar = true"
					></v-btn>
				</v-col>
			</v-row>
		</template>
		<v-container fliud v-if="isCadastroOuEditar">
			<v-form ref="formAgencia" fast-fail :disabled="loading" @submit.prevent="handleAgencia()">
				<v-row>
					<v-col cols="12" md="12" align="center">
						<v-checkbox v-model="dadosAgencia.registroAtivo" :color="corTexto" label="Agência ativa" />
					</v-col>
					<v-col cols="12" md="4">
						<div class="mb-2 mr-6"><span class="required">* </span>Nome da Agência</div>
						<v-text-field v-model="dadosAgencia.nome" :rules="validarAgencias.nome" />
					</v-col>
					<v-col cols="12" md="4">
						<div class="mb-2 mr-6"><span class="required">* </span>Nome do Coordenador</div>
						<v-text-field v-model="dadosAgencia.coordenador" :rules="validarAgencias.coordenador" />
					</v-col>
					<v-col cols="12" md="4">
						<div class="mb-2 mr-6"><span class="required">* </span>Horário de Funcionamento</div>
						<v-text-field v-model="dadosAgencia.horarioFuncionamento" :rules="validarAgencias.horarioFuncionamento" />
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="6" align="start">
						<v-btn :color="corTexto" variant="outlined" :loading="loading" @click="cancelarCadastro()">
							CANCELAR
						</v-btn>
					</v-col>
					<v-col cols="6" align="end">
						<v-btn color="primary" type="submit" :loading="loading" :disabled="desabilitaAvancar">
							{{ dadosAgencia.id ? "SALVAR" : "CADASTRAR" }}
						</v-btn>
					</v-col>
				</v-row>
			</v-form>
		</v-container>
		<v-container fluid v-else>
			<v-row>
				<v-col cols="12" md="4">
					<div class="mb-2 mr-6 text-hidden">Nome da Agência</div>
					<v-text-field v-model="filtros.nome" />
				</v-col>
				<v-col cols="12" md="4" align="center">
					<v-checkbox v-model="filtros.registroAtivo" class="mt-6" :color="corTexto" label="Agências ativas" />
				</v-col>
				<v-col cols="6" md="2" class="align-content-center">
					<v-btn
						block
						:color="corTexto"
						variant="outlined"
						text="LIMPAR"
						@click="limparFiltros"
					></v-btn>
				</v-col>
				<v-col cols="6" md="2" class="align-content-center">
					<v-btn
						block
						color="primary"
						text="PESQUISAR"
						@click="consultaAgencias()"
					></v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12">
					<v-data-table
						:loading="loading"
						:page="pagination.currentPage"
						:items-per-page="pagination.perPage"
						:headers="headers"
						:server-items-length="pagination.totalRows"
						:items="listaAgencias"
						no-data-text="Nenhum dado encontrado!"
						loading-text="Carregando..."
						:footer-props="{
							itemsPerPageText: 'Itens por página: ',
							disableItemsPerPage:true,
							disablePagination:true,
						}"
						hide-default-footer
						>
						<template v-slot:item.registroAtivo="{ item }">
							<div align="center">
								<v-icon :color="item.registroAtivo ? 'success' : 'error'" :icon="item.registroAtivo ? 'mdi-check' : 'mdi-close'" size="large" />
							</div>
						</template>
						<template v-slot:item.acoes="{ item }">
							<v-btn
								block
								color="primary"
								text="EDITAR"
								@click="{
									isCadastroOuEditar = true;
									dadosAgencia = item;
								}"
							></v-btn>
						</template>
					</v-data-table>
					<v-container class="mt-0 pa-0">
						<v-row class="pa-0">
							<v-col class="ml-2 d-flex align-center">
								<span class="mr-5 mt-3 fs-15">{{ textoPaginacao }}</span>
							</v-col>
							<v-col class="d-flex justify-end">
								<v-pagination
									:disabled="loading"
									total-visible=7
									:model-value="pagination.currentPage"
									@update:model-value="(event) => pagination.currentPage = event"
									:length="pagination.totalPages"
									/>
							</v-col>
						</v-row>
					</v-container>
				</v-col>
			</v-row>
		</v-container>
	</ViewWrapper>
</template>
<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import ViewWrapper from '@/components/commons/wrapper/ViewWrapper.vue';
import { ErroAlert, SucessoAlert } from "@/utils/AlertUtils.js";
import { vuetify } from '@/plugins/vuetify'
import { PERMISSOES_FGTAS } from '@/utils/PermissaoUtils';
import { buscarAgenciasPaginado, cadastrarAgencia, editarAgencia } from '@/services/AgenciaService';
import { validarAgencias } from '@/utils/ValidacoesUtils';

const headers = [
	{ key: "nome", title: "AGÊNCIA", sortable: false },
	{ key: "coordenador", title: "COORDENADOR", sortable: false },
	{ key: "horarioFuncionamento", title: "HORÁRIO DE FUNCIONAMENTO", sortable: false },
	{ key: "dataInicio", title: "DATA DE CADASTRO", sortable: false, align: "center" },
	{ key: "registroAtivo", title: "AGÊNCIA ATIVA", sortable: false, align: "center" },
	{ key: "acoes", title: "AÇÕES", sortable: false, align: "center" },
];

const formAgencia = ref();
const loading = ref(false);
const isCadastroOuEditar = ref(false);
const listaAgencias = ref([]);
const filtros = ref({
	nome: undefined,
	registroAtivo: true,
	sort: "nome,asc"
});

const pagination = ref({
	page: 0,
	size: 10,
	perPage: 10,
	currentPage: 1,
	totalRows: 0,
	totalPages: 0,
});

const dadosAgencia = ref({
	id: undefined,
	nome: "",
	coordenador: "",
	horarioFuncionamento: "",
	registroAtivo: true,
});

const desabilitaAvancar = computed(() => {
	const ignorarCampos = ["id", "registroAtivo"];
	const formValido = Object.keys(dadosAgencia.value).every(key => {
		if (ignorarCampos.includes(key)){
			return true;
		}
		return !!dadosAgencia.value[key] && dadosAgencia.value[key] !== "";
	});
	let contemErro = false;
	if (formAgencia.value) {
		contemErro = !!formAgencia.value.errors.length
	}
	return !formValido || contemErro;
});

const corTexto = computed(() => {
	return vuetify.theme.current.value.dark ? "white" : "primary";
});

const textoPaginacao = computed(() => {
	if(pagination.value.totalRows){
		if(pagination.value.totalRows === 0){
			return "Nenhum registro localizado";
		}
		if(pagination.value.totalRows === 1){
			return "1 registro recuperado";
		}
		return `${pagination.value.totalRows} registros recuperados`;
	}
	return "";
});

async function consultaAgencias(page) {
	pagination.value.currentPage = page ? pagination.value.currentPage : 1;
	pagination.value.page = page ? pagination.value.currentPage - 1 : 0;
	loading.value = true;
	await buscarAgenciasPaginado({
		page: pagination.value.page,
		size: pagination.value.size,
		perPage: pagination.value.perPage,
		currentPage: pagination.value.currentPage,
		sort: filtros.value.sort ? filtros.value.sort : undefined,
	}, {
		nome: filtros.value.nome ? filtros.value.nome : undefined,
		registroAtivo: filtros.value.registroAtivo,
	})
		.then(({ data }) => {
			pagination.value.size = data.size;
			pagination.value.totalPages = data.totalPages;
			listaAgencias.value = data.content;
			pagination.value.totalRows = data.totalElements;
		})
		.catch((error) => {
			ErroAlert({ mensagem: "Não foi possível listar as agências no momento. Tente novamente mais tarde!", error });
		})
		.finally(() => loading.value = false);
}

function cancelarCadastro() {
	isCadastroOuEditar.value = false;
	dadosAgencia.value = {
		id: undefined,
		nome: "",
		coordenador: "",
		horarioFuncionamento: "",
		registroAtivo: true,
	};
}

async function limparFiltros() {
	filtros.value.nome = undefined;
	filtros.value.registroAtivo = true;
	await consultaAgencias();
};

async function editar() {
	loading.value = true;
	await editarAgencia(dadosAgencia.value.id, dadosAgencia.value)
		.then(async () => {
			SucessoAlert({ mensagem: "Agência editada com sucesso!" });
			isCadastroOuEditar.value = false;
			dadosAgencia.value = {
				id: undefined,
				nome: "",
				coordenador: "",
				horarioFuncionamento: "",
				registroAtivo: true,
			}
			filtros.value.nome = undefined;
			filtros.value.registroAtivo = true;
			await consultaAgencias();
		})
		.catch((error) => {
			ErroAlert({ mensagem: error.response.data.mensagem, error });
		})
		.finally(() => loading.value = false);
}

async function cadastrar() {
	loading.value = true;
	await cadastrarAgencia(dadosAgencia.value)
		.then(async () => {
			SucessoAlert({ mensagem: "Agência cadastrada com sucesso!" });
			isCadastroOuEditar.value = false;
			dadosAgencia.value = {
				id: undefined,
				nome: "",
				coordenador: "",
				horarioFuncionamento: "",
				registroAtivo: true,
			}
			filtros.value.nome = undefined;
			filtros.value.registroAtivo = true;
			await consultaAgencias();
		})
		.catch((error) => {
			ErroAlert({ mensagem: error.response.data.mensagem, error });
		})
		.finally(() => loading.value = false);
}

async function handleAgencia() {
	if (dadosAgencia.value && dadosAgencia.value.id) {
		await editar();
		return;
	}
	await cadastrar();
}

watch(() => pagination.value.currentPage, async (newValue, oldValue) => {
	if (newValue !== oldValue) {
		await consultaAgencias(newValue);
	}
}, { deep: true });

onMounted(async () => {
	await consultaAgencias();
});
</script>

<style lang="css" scoped>
.radio {
	display: inline-flex;
}
.required {
	color: red;
}
</style>
